import { useContext, useEffect, type FC } from "react";
import { LayoutActionsContext, type ILayoutSubMenu } from "src/contexts/layouts/LayoutContext";

interface ISetPageSubMenusProps {
    subMenu: ILayoutSubMenu;
}

const AddPageSubMenu: FC<ISetPageSubMenusProps> = ({ subMenu }) => {
    const layoutContext = useContext(LayoutActionsContext);

    useEffect(() => {
        layoutContext.addSubMenu(subMenu);

        return () => {
            layoutContext.removeSubMenu(subMenu);
        };
    }, [subMenu, layoutContext]);

    return null;
};

export default AddPageSubMenu;
